import { render } from "./SuspenseRoute.vue?vue&type=template&id=486758f1"
import script from "./SuspenseRoute.vue?vue&type=script&lang=js"
export * from "./SuspenseRoute.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__